// B2B lead-hero (sections/b2b-lead-hero.liquid): de tweede formulierstap en de
// vaste knop op mobiel.
//
// Het versturen zelf doet de bestaande formulierverwerking (js-form-builder-form
// in app.js): die vervangt een geslaagd formulier door een bevestiging. Dat
// moment vangen we hier op om stap 2 te tonen, met de gegevens uit stap 1 in de
// verborgen velden, zodat beide inzendingen bij elkaar horen.
(() => {
  const root = document.querySelector('.js-b2b-lead');

  // Eén keer per pagina, ook als het script (bv. in de editor) twee keer laadt.
  if (!root || root.dataset.b2bLeadReady) {
    return;
  }

  root.dataset.b2bLeadReady = 'true';

  const step1 = root.querySelector('.js-b2b-lead-step1');
  const step2 = root.querySelector('.js-b2b-lead-step2');
  const done = root.querySelector('.js-b2b-lead-done');
  const form1 = document.getElementById(root.dataset.step1);
  const form2 = document.getElementById(root.dataset.step2);
  const sticky = root.querySelector('.js-b2b-lead-sticky');
  let submitted = null;
  let leadDone = false;

  const show = (element) => {
    [step1, step2, done].forEach((step) => {
      if (step) {
        step.hidden = step !== element;
      }
    });
  };

  // De waarden van stap 1 bewaren op het moment van versturen; daarna is het
  // formulier al vervangen door de bevestiging.
  if (form1) {
    form1.addEventListener(
      'submit',
      () => {
        const data = new FormData(form1);
        submitted = {
          first_name: (data.get('first_name') || '').toString().trim(),
          name: (data.get('name') || '').toString().trim(),
          email: (data.get('email') || '').toString().trim(),
          phone: (data.get('phone') || '').toString().trim(),
          project_type: (data.get('project_type') || '').toString(),
        };
      },
      true,
    );
  }

  const openStep2 = () => {
    leadDone = true;
    updateSticky();

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'b2b_lead',
      leadSource: form1 ? form1.querySelector('[name="lead_source"]').value : '',
      projectType: submitted ? submitted.project_type : '',
    });

    if (!step2 || !form2 || !submitted) {
      return;
    }

    form2.querySelectorAll('.js-b2b-lead-copy').forEach((input) => {
      input.value = submitted[input.dataset.field] || '';
    });

    const name = step2.querySelector('.js-b2b-lead-name');
    if (name && submitted.first_name) {
      name.textContent = `, ${submitted.first_name}`;
    }

    show(step2);
  };

  // Geslaagd = het formulier is uit stap 1 verdwenen en er staat een
  // bevestiging. Bij een fout blijft het formulier staan (met de melding erin).
  if (step1 && form1) {
    new MutationObserver((mutations, observer) => {
      if (!step1.contains(form1) && step1.querySelector('.note--success')) {
        observer.disconnect();
        openStep2();
      }
    }).observe(step1, { childList: true, subtree: true });
  }

  // Uploadveld: de gekozen bestanden tonen in plaats van "Kies bestanden".
  const files = root.querySelector('.js-b2b-lead-files');
  const filesText = root.querySelector('.js-b2b-lead-files-text');
  if (files && filesText) {
    files.addEventListener('change', () => {
      const names = [...files.files].map((file) => file.name);
      if (!names.length) {
        filesText.textContent = filesText.dataset.empty;
      } else if (names.length === 1) {
        filesText.textContent = names[0];
      } else {
        filesText.textContent = `${names.length} bestanden: ${names.join(', ')}`;
      }
      filesText.closest('.b2b-lead__upload-box').classList.toggle('has-files', names.length > 0);
    });
  }

  const skip = root.querySelector('.js-b2b-lead-skip');
  if (skip) {
    skip.addEventListener('click', () => show(done));
  }

  // Vaste knop op mobiel: alleen zolang het formulier niet in beeld is en de
  // aanvraag nog niet verstuurd werd. De afsluitende oproep onderaan de pagina
  // telt ook als "in beeld": twee knoppen tegelijk is er één te veel.
  let cardVisible = true;
  let ctaVisible = false;

  function updateSticky() {
    if (sticky) {
      sticky.hidden = leadDone || cardVisible || ctaVisible;
    }
  }

  const card = root.querySelector('.b2b-lead__card');
  if (sticky && card && 'IntersectionObserver' in window) {
    new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        cardVisible = entry.isIntersecting;
      });
      updateSticky();
    }).observe(card);

    const finalCta = document.querySelector('.b2b-final-cta');
    if (finalCta) {
      new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          ctaVisible = entry.isIntersecting;
        });
        updateSticky();
      }).observe(finalCta);
    }
  }
})();
